import { h, render, Component } from 'preact';

export class PickDeviceType extends Component {

  chooseDeviceType = type => e => {
    var nextScreen = 'pickDeviceOS';
    if(type=='landline') {
      nextScreen = 'registerNumber';
    }

		this.props.updateWizard({
      screen: nextScreen,
      deviceType: type
    });
  }

  render(props, state) {
		return (
				<div class="touchOptions">
					<div class="touchBtn" onClick={this.chooseDeviceType('mobile')}><i class="fa fa-mobile fa-3x"></i><div>Smartphone<br/>(recommended)</div></div>
					<div class="break"></div>
					<div class="touchBtn" onClick={this.chooseDeviceType('tablet')}><i class="fa fa-tablet fa-3x"></i><div>Tablet<br/>(iPad, Fire, etc..)</div></div>
					<div class="touchBtn" onClick={this.chooseDeviceType('landline')}><i class="fa fa-phone fa-3x"></i><div>Landline<br/>(voice only)</div></div>
				</div>
		)
  }
}
